// extracted by mini-css-extract-plugin
export default {"modalHeader":"xaa-z","modalContent":"yaa-z","formWrapper":"zaa-z","fade":"Aaa-z","fade-in":"Baa-z"};